// 手机号验证
export function validPhone (rule, value, callback) {
  // let reg = /^1[345789]\d{9}$/ // 不包含虚拟虚拟运营商
  let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

export function emptyValidPhone (rule, value, callback) {
  let reg = /^1[345789]\d{9}$/
  if (value === '') {
    callback()
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

// 固定电话号码验证
export function validTel (str) {
  const reg = /^0\d{2,3}-?\d{7,8}$/
  return reg.test(str)
}

// 用户密码验证
export function checkPassword (str) {
  let passwordReg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]+$/
  if (str.indexOf(' ') > -1) {
    return '不能包含空格'
  } else if (str.length > 20 || str.length < 6) {
    return '长度必须为6-20位'
  } else if (!passwordReg.test(str)) {
    return '必须包含字母、数字、特殊符号中至少两种'
  } else {
    return false
  }
}

export function validPassword (rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else {
    if (checkPassword(value)) {
      callback(new Error(checkPassword(value)))
    } else {
      callback()
    }
  }
}
export function validBankAccount (rule, value, callback) {
  let reg = /^([1-9]{1})(\d{11}|\d{15}|\d{16}|\d{17}|\d{18})$/
  if (!reg.test(value)) {
    callback(new Error('请输入正确的银行账户'))
  } else {
    callback()
  }
}
export function vaildIDCard (rule, value, callback) {
  let reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  if (!reg.test(value)) {
    callback(new Error('请输入正确的身份证号'))
  } else {
    callback()
  }
}

/**
 * 
 * @param idCard 
 * @returns 出生年月
 */
export function getBirth (idCard) {
  var birthday = ""
  if (idCard !== null && idCard !== "") {
      if (idCard.length === 15) {
          birthday = "19" + idCard.slice(6, 12);
      } else if (idCard.length === 18) {
          birthday = idCard.slice(6, 14);
      }   
      birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      // 通过正则表达式来指定输出格式为:1990-01-01
  }   
  return birthday;
}
/**
* @param idCard
* @returns 性别 1 男 2 女
*/
export function getSex (idCard) {
  var sexStr = ''
  if (parseInt(idCard.slice(-2, -1)) % 2 === 1) {
      sexStr = 1
  } else {
      sexStr = 2
  }
  return sexStr
}